import { translateRaw } from './globalTranslator';

const CODE_TO_MESSAGE = {
  USER_NOT_IN_DATABASE: 'User account not found. Please complete registration.',
  AUTH_TOKEN_MISSING: 'No token provided',
  AUTH_TOKEN_EXPIRED: 'Token expired',
  AUTH_TOKEN_REVOKED: 'Token revoked',
  AUTH_INVALID_TOKEN: 'Invalid ID token',
  AUTH_UNAUTHORIZED: 'Unauthorized',
  AUTH_USER_NOT_AUTHENTICATED: 'Unauthorized: User not authenticated.',
  AUTH_ROLE_NOT_FOUND: 'Unauthorized: User role not found.',
  AUTH_ROLE_FORBIDDEN: 'Forbidden: Your role is not allowed to perform this action.',
  AUTH_ROLE_PARTNER_REQUIRED: 'Forbidden: This action requires a partner role.',
  AUTH_ROLE_CLIENT_REQUIRED: 'Forbidden: This action requires a client role.',
  AUTH_ROLE_ADMIN_REQUIRED: 'Forbidden: This action requires an admin role.',
  USER_NOT_APPROVED: 'This user has not been approved',
  USER_EMAIL_NOT_VERIFIED: 'User email has not been verified',
  USER_DISABLED: 'User account has been disabled',
  BOOKING_NOT_FOUND: 'Booking not found',
  ROUTE_NOT_FOUND: 'Route not found',
  BOOKING_PICKUP_LOCATION_REQUIRED:
    'Pickup location (country and postalCode) is required',
  BOOKING_DELIVERY_LOCATION_REQUIRED:
    'Delivery location (country and postalCode) is required',
  ROUTE_CALCULATION_UNAVAILABLE:
    'Unable to calculate route. Please check the locations and try again.',
  BOOKING_PRICE_CALCULATION_FAILED: 'Error calculating transport price',
  BOOKING_CANCELED: 'Booking canceled successfully',
  BAD_REQUEST: 'Invalid request.',
  FORBIDDEN: 'Access denied.',
  NOT_FOUND: 'Resource not found.',
  CONFLICT: 'Request conflict.',
  UNPROCESSABLE_ENTITY: 'Invalid data provided.',
  RATE_LIMITED: 'Too many requests. Please try again later.',
  INTERNAL_ERROR: 'Internal server error. Please try again later.',
  BAD_GATEWAY: 'Service temporarily unavailable.',
  SERVICE_UNAVAILABLE: 'Service temporarily unavailable.',
};

export const translateApiError = (
  error,
  fallback = 'An unexpected error occurred.'
) => {
  const code = error?.response?.data?.code;
  if (code && CODE_TO_MESSAGE[code]) {
    return translateRaw(CODE_TO_MESSAGE[code]);
  }

  const message =
    error?.response?.data?.message || error?.message || fallback || '';
  return translateRaw(message);
};
